import { useParams } from 'react-router-dom'
import PageWrapper from '@/components/page-wrapper'
import { products } from '@/assets/content/products'
import Banner from './components/banner'
import Features from './components/features'
import Spec from './components/spec'
import Certificate from './components/certificate'

export default function ProductTemplate() {
  const { name } = useParams()
  const product = products.find(item => item.pathName === name)
  const { banner, title, description, features, specImages, certificateImages } = product || {}

  if (!product) {
    return <PageWrapper>404</PageWrapper>
  }

  return (
    <PageWrapper>
      <Banner title={title} description={description} image={banner} />
      <Features data={features} />
      <Spec images={specImages} />
      <Certificate images={certificateImages} />
    </PageWrapper>
  )
}
